import token, { tokenToVars } from '../token';
import DatePicker from './date-picker';

export { DatePicker };
export default tokenToVars(DatePicker, token);
